import { reaction } from "mobx"
import { useEffect, useState } from "react"

import type { IStudentUserInfo } from "~/domain/user-session"
import { userSessionStore } from "~/domain/user-session/model/store"

/**
 * Возвращает доп. информацию о студенте, если она есть
 * @hook
 * @category Hook
 */
export function useStudentUserInfo(): Partial<IStudentUserInfo> {
	const [studentUserInfo, setStudentUserInfo] = useState<
		Partial<IStudentUserInfo>
	>(userSessionStore.studentUserInfo || {})

	useEffect(() => {
		return reaction(
			() => userSessionStore.studentUserInfo,
			(newStudentUserInfo) =>
				setStudentUserInfo(newStudentUserInfo || {}),
		)
	}, [])

	return studentUserInfo
}
